/**
 * @param {number} placeId
 * @param {{ type: String | Null, customAttributeName: String | Null }} arg
 * @return {['unknown'] | ['place', number, String]}
 */
export const placeFocusPath = (placeId, { type, customAttributeName }) => {
  // NOTE(ed): restoring this check because old tests depended on it
  // and it therefore *might* happen in production.
  if (typeof placeId !== 'number') {
    return ['unknown']
  } else if (typeof customAttributeName === 'string') {
    return ['place', placeId, customAttributeName]
  } else if (typeof type === 'string' && ['name', 'description', 'notes'].indexOf(type) !== -1) {
    return ['place', placeId, type]
  } else {
    return ['unknown']
  }
}
